module.exports = __webpack_public_path__ + "media/2_4.6bd70017.wav";